module.exports = __webpack_public_path__ + "img/op_five_steps.87261bef.png";